import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { onUnauthorized, qk } from './lib/api'
import { onPartnerUnauthorized, ppk } from './modules/partner-portal/api'
import { buildRouter } from './router'
import './styles.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: { staleTime: 30_000, refetchOnWindowFocus: false },
  },
})

const router = buildRouter(queryClient)

const PUBLIC_PATHS = new Set(['/login', '/two-factor'])

// A 401 anywhere means the session ended: forget the user and go to sign-in.
onUnauthorized(() => {
  queryClient.setQueryData(qk.me, null)
  const { pathname, href } = router.state.location
  if (!PUBLIC_PATHS.has(pathname)) void router.navigate({ to: '/login', search: { redirect: href } })
})

// The partner portal has its own session: a 401 there goes to the partner sign-in.
const PARTNER_PUBLIC = new Set(['/partner/login', '/partner/two-factor', '/partner/accept'])
onPartnerUnauthorized(() => {
  queryClient.setQueryData(ppk.me, null)
  if (!PARTNER_PUBLIC.has(router.state.location.pathname)) void router.navigate({ to: '/partner/login' })
})

const root = document.getElementById('root')
if (!root) throw new Error('Missing #root element')

createRoot(root).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
)
